<div class="panel-div no-billing-address" [class.active]="isActive === true" yatTabSelectable (tabSelect)="onClick()">
  <div class="row">
    <div class="col-12">
      <div class="icons">
        <ng-container *ngIf="isActive === true; else notActive">
          <span class="icon-static">
            <yat-icon id="111fa333-5d0b-4159-9202-2d40dc1e32ff" name="tick-circle-duo" class="active"></yat-icon>
          </span>
        </ng-container>
        <ng-template #notActive>
          <span>
            <yat-icon id="ec3770cc-fa8e-4493-95e6-eab0477504c5" name="tick-circle-duo"></yat-icon>
          </span>
        </ng-template>
      </div>
      <p class="beside-icons">
        {{ 'checkout.billingInformation.noBillingAddress.noBillingAddress' | transloco }}
      </p>
    </div>
  </div>
</div>
